import English from "../components/English";

function EnglishPage(){
    return <div>
        <English/>
    </div>
}

export default EnglishPage;